import { Component, OnInit } from '@angular/core';
import { FlyingAgentsService } from '../../service/flying-agents.service';

@Component({
  selector: 'app-flying-agents',
  standalone: false,
  templateUrl: './flying-agents.component.html',
  styleUrl: './flying-agents.component.scss'
})
export class FlyingAgentsComponent implements OnInit {
  data: any[] = []
  constructor(
    private flyingAgentService: FlyingAgentsService
  ) { }


  async ngOnInit(): Promise<void> {
    let result = await this.flyingAgentService.getAllAgentPrompts();
  }
}
